export default __webpack_public_path__ + "static/media/STRYKER 125_5.5c2b775b.webp";